/* src/app/old-settings/email-redirection/email-redirection.component.scss */
/*# sourceMappingURL=email-redirection.component-G2I7W5VU.css.map */
